/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */

// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { State } from '../../model/types.tsx';

export const setContainerType =
	(containerType: 'project' | 'plan'): Action<State> =>
	({ getState, setState }) => {
		const { containerType: currentContainerType } = getState();

		if (containerType === currentContainerType) {
			// if state has not been updated we just return
			return;
		}

		setState({ containerType });
	};

export default setContainerType;
